import TestimonialCarousel from './testimonial-carousel.js';
import data from '../../../data/testimonials';

const Testimonials = () => {
  return (
    <div className="swiper testimonials">
      <div className="swiper-wrapper">
        <div className="swiper-slide">
          <div className="container-xl">
            <div className="row justify-content-center">
              <div className="col-sm-9 text-center">
                <p className="mb-2 fs-5 text-white">
                  <strong>Reviews &amp; Testimonials</strong>
                </p>
                <TestimonialCarousel data={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

module.exports = Testimonials;
